import React, { useState } from "react";
import { Link } from "react-router-dom";
import i18n from "eth-common/i18n/i18n";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Table,
} from "react-bootstrap";
import { FetchWithAuth } from "digimaker-ui/util";

export const StartSigning = (props: { report: any; onSuccess: () => void }) => {
  const { report } = props;

  const [shown, setShown] = useState(false);
  const [loading, setLoading] = useState(false);

  const emptyRecord = { name: "", email: "" };

  const [receivers, setReceivers] = useState<
    Array<{ name: string; email: string }>
  >([emptyRecord]);

  const add = () => {
    setReceivers([...receivers, emptyRecord]);
  };

  const change = (index: number, t: string, v: string) => {
    const newReceivers = [...receivers];
    const newRow = { ...receivers[index] };
    if (t === "name") {
      newRow.name = v;
    } else if (t === "email") {
      newRow.email = v;
    }
    newReceivers[index] = newRow;
    setReceivers(newReceivers);
  };

  const deleteRow = (index: number) => {
    const newReceivers = [...receivers];
    newReceivers.splice(index, 1);
    setReceivers(newReceivers);
  };

  const start = () => {
    setLoading(true);
    FetchWithAuth("eth/signing/start/" + report.location.id, {
      method: "POST",
      body: JSON.stringify(receivers),
    }).then((data) => {
      setLoading(false);
      if (data.data === true) {
        window.alert("Successfully started");
        setShown(false);
        props.onSuccess();
      } else {
        window.alert(data.data.message);
      }
    });
  };

  return (
    <>
      <div>
        <Button size="sm" onClick={() => setShown(true)}>
          {" "}
          {i18n.t("Start signing")}
        </Button>
        <Modal show={shown} centered size="lg">
          <ModalTitle style={{ padding: 10 }}>Start signing</ModalTitle>
          <ModalBody>
            <Table className="table">
              <thead>
                <th></th>
                <th>Name</th>
                <th>Email</th>
                <th></th>
              </thead>
              {receivers.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      className="form-control"
                      value={item.name}
                      onChange={(e) => change(index, "name", e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={item.email}
                      onChange={(e) => change(index, "email", e.target.value)}
                    />
                  </td>
                  <td>
                    <Button variant="light" onClick={() => deleteRow(index)}>
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </Table>
            <Button variant="secondary" size="sm" onClick={add}>
              Add
            </Button>
          </ModalBody>
          <ModalFooter>
            {loading && <span className="loading"></span>}
            <Button disabled={loading} onClick={start}>
              Start
            </Button>
            <Button
              disabled={loading}
              variant="light"
              onClick={() => setShown(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};
